import { useState } from 'react';
import {
  Box, Divider, Typography, IconButton, Menu, MenuItem,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  removePlayer, removePlayerFromTeam, changePlayerType, setPlayerTeam, checkOut, toggleStayIn,
} from 'redux/slices';
import SportsHandballIcon from '@mui/icons-material/SportsHandball';
import SportsVolleyballIcon from '@mui/icons-material/SportsVolleyball';
import FemaleIcon from '@mui/icons-material/Female';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';

export default function CurrentPlayerCard({ player }) {
  const dispatch = useDispatch();
  const { showWinPercentage, playersPerTeam } = useSelector((state) => state.game);
  const otherTeamId = player.teamId === 1 ? 2 : 1;
  const otherTeamSize = useSelector(
    (state) => state.players.filter((p) => p.teamId === otherTeamId).length,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const { playerType } = player;

  const dispatchPlayerType = (type) => {
    dispatch(changePlayerType({ playerId: player.playerId, playerType: type }));
  };

  const handleClick = () => {
    const isAttacker = playerType === 'Attacker';
    const isSetter = playerType === 'Setter';
    const isFlex = playerType === 'Flex';
    const isBoth = playerType === 'Both';
    if (isSetter) { return dispatchPlayerType('Attacker'); }
    if (isAttacker) { return dispatchPlayerType('Flex'); }
    if (isFlex) { return dispatchPlayerType('Both'); }
    if (isBoth) { return dispatchPlayerType('Setter'); }
    return dispatchPlayerType('Setter');
  };

  const handleRemovePlayer = () => {
    dispatch(removePlayer(player.playerId));
    dispatch(removePlayerFromTeam({ teamId: player.teamId, playerId: player.playerId }));
  };

  const isSetter = player.playerType === 'Setter';
  const isAttacker = player.playerType === 'Attacker';
  const isBoth = player.playerType === 'Both';

  return (

    <Box sx={{
      width: { xs: '100%', md: '80%' },
    }}
    >
      <Box
        key={`${player.playerId}-${player.playerName}`}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          borderRadius: '5px',
          padding: '10px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          <Typography onClick={handleClick} variant="h6">
            <Typography
              component="span"
              variant="body2"
              sx={{ color: 'primary.main', fontWeight: 'bold', mr: 0.5 }}
            >
              {showWinPercentage
                ? `${(player.dailyGames || 0) > 0 ? Math.round(((player.dailyWins || 0) / (player.dailyGames || 1)) * 100) : 0}%`
                : `${player.dailyWins || 0}/${player.dailyGames || 0}`}
            </Typography>
            {player.playerName}
          </Typography>
          {isAttacker && <SportsHandballIcon onClick={handleClick} sx={{ marginLeft: '-15px', color: 'primary.main', height: '30px' }} /> }
          {isSetter && <SportsVolleyballIcon onClick={handleClick} sx={{ marginLeft: '-15px', color: 'red', height: '30px' }} /> }
          {isBoth && (
          <Box
            sx={{
              display: 'flex',
              gap: 2,
            }}
          >
            <SportsHandballIcon onClick={handleClick} sx={{ marginLeft: '-15px', color: 'primary.main', height: '30px' }} />
            <SportsVolleyballIcon onClick={handleClick} sx={{ marginLeft: '-15px', color: 'red', height: '30px' }} />
          </Box>
          )}
          {player.gender === 'F' && <FemaleIcon sx={{ marginLeft: '-10px', color: 'deeppink', height: '30px' }} />}
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <SwapHorizIcon
            sx={{ cursor: 'pointer', color: 'primary.main' }}
            onClick={() => {
              if (otherTeamSize >= playersPerTeam) {
                alert(`O Time ${otherTeamId === 1 ? 'A' : 'B'} já está completo.`);
                return;
              }
              dispatch(setPlayerTeam({ playerId: player.playerId, teamId: otherTeamId }));
            }}
          />
          <IconButton
            size="small"
            onClick={handleRemovePlayer}
            sx={{ color: 'error.main' }}
          >
            <DeleteIcon />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={() => {
              dispatch(removePlayerFromTeam({ playerId: player.playerId, teamId: player.teamId }));
              dispatch(removePlayer(player.playerId));
              dispatch(checkOut(player.playerId));
              setAnchorEl(null);
            }}
            >
              Checkout
            </MenuItem>
            <MenuItem onClick={() => {
              dispatch(toggleStayIn(player.playerId));
              setAnchorEl(null);
            }}
            >
              {player.stayIn ? 'Regular' : 'Stay In'}
            </MenuItem>
          </Menu>
        </Box>
      </Box>
      <Divider variant="fullWidth" />
    </Box>
  );
}
